export default {
  outbound: 'Outbound',
  inbound: 'Return',
  hide: 'Hide',
  details: 'Details',
}
